import { actions, paths } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getCollections: (page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.READ_AND_THINK_COLLECTIONS_GET_REQUEST,
        actions.READ_AND_THINK_COLLECTIONS_GET_SUCCESS,
        actions.READ_AND_THINK_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.READ_AND_THINK, {
          params: {
            page,
            pageSize,
          },
        }),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.READ_AND_THINK_LEVELS_GET_REQUEST,
        actions.READ_AND_THINK_LEVELS_GET_SUCCESS,
        actions.READ_AND_THINK_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.READ_AND_THINK_COLLECTIONS_ID_LEVELS,
            collectionId
          )
        ),
    },
  }),
  getBonusLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.READ_AND_THINK_BONUS_LEVELS_GET_REQUEST,
        actions.READ_AND_THINK_BONUS_LEVELS_GET_SUCCESS,
        actions.READ_AND_THINK_BONUS_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.READ_AND_THINK_COLLECTIONS_ID_BONUS_LEVELS,
            collectionId
          )
        ),
    },
  }),
  resetState: () => ({
    type: actions.READ_AND_THINK_LEVELS_RESET,
  }),
};
